import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getDamzModule } from './module';
import useNCI18next from '../hooks/useI18next';

export interface Props {}

// Uses function component to avoid const creating Cannot access 'N' before initialization errors
export default function ModuleLoader() {
  useNCI18next();
  return <DynamicModuleLoader modules={[getDamzModule()]} />;
}
ModuleLoader.displayName = 'ModuleLoader';
